import { Action } from 'redux';
import { CoreActions } from './actionTypes';
import { CoreState } from './models';

const initialState: CoreState = {
    ajaxCallInProgress: 0,
    lingua: 'it',
    anagrafiche: { lista: [], anagrafica: undefined, refreshAnagrafiche: false},
    tenant: undefined,
    auth: { loggedIn: false, expired: false, user: undefined },
    moduli: {
        admin: false,
        archiviazione: false,
        ordini: false,
        chiamate: false,
        chiamateArchivi: false,
    }
}

export default (
    state: CoreState = initialState,
    incomingAction: Action
): CoreState => {
    const action = incomingAction as CoreActions;
    switch (action.type) {
        case 'core/BEGIN_AJAX_CALL': 
            return { 
                ...state, 
                ajaxCallInProgress: state.ajaxCallInProgress + 1
            };
        case 'core/END_AJAX_CALL':
            return { 
                ...state, 
                ajaxCallInProgress: state.ajaxCallInProgress - 1
            };
        case 'core/LOAD_TENANT':
            return {
                ...state,
                tenant: action.value
            };
        case 'core/LOAD_MODULI':
            return {
                ...state,
                moduli: action.value
            }
        case 'core/LOAD_ANAGRARICHE':
            return {
                ...state,
                anagrafiche: {
                    ...state.anagrafiche,
                    lista: action.value
                }
            };
        case 'core/ANAGRAFICA_SELEZIONATA':
            return {
                ...state,
                anagrafiche: {
                    ...state.anagrafiche,
                    anagrafica: action.value
                }
            };
        case 'core/MODIFICA_ANAGRAFICA':
            return {
                ...state,
                anagrafiche: {
                    ...state.anagrafiche,
                    anagrafica: undefined
                }
            };

        case 'core/LOGIN_SUCCESS':
            return {
                ...state,
                auth: {
                    user: action.user,
                    loggedIn: true,
                    expired: action.user.expired
                }
            };
        case 'core/LOGIN_ERROR':
        case 'core/LOGOUT_SUCCESS':
            return {
                ...state,
                auth: {
                    user: undefined,
                    loggedIn: false,
                    expired: false,
                }
            };
        case 'core/USER_EXPIRED':
            return {
                ...state,
                auth: {
                    ...state.auth,
                    expired: true,
                }
            };

        default: return state;
    }
};